import { FlagDef } from "./flag-def";

const EnglishFlag: FlagDef = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_125_13182)">
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="#F0F0F0"
      />
      <path
        d="M2.48069 4.69299C1.53808 5.91938 0.827311 7.3329 0.413452 8.86848H6.65617L2.48069 4.69299Z"
        fill="#0052B4"
      />
      <path
        d="M23.587 8.86864C23.1731 7.33311 22.4623 5.9196 21.5198 4.69321L17.3444 8.86864H23.587Z"
        fill="#0052B4"
      />
      <path
        d="M0.413452 15.1302C0.827359 16.6657 1.53812 18.0793 2.48069 19.3056L6.65603 15.1302H0.413452Z"
        fill="#0052B4"
      />
      <path
        d="M19.3056 2.47979C18.0792 1.53718 16.6657 0.826413 15.1301 0.412506V6.65518L19.3056 2.47979Z"
        fill="#0052B4"
      />
      <path
        d="M4.69397 21.5177C5.92036 22.4603 7.33388 23.1711 8.86941 23.585V17.3424L4.69397 21.5177Z"
        fill="#0052B4"
      />
      <path
        d="M8.86936 0.412506C7.33383 0.826412 5.92031 1.53718 4.69397 2.47974L8.86936 6.65513V0.412506Z"
        fill="#0052B4"
      />
      <path
        d="M15.1301 23.585C16.6657 23.1711 18.0792 22.4603 19.3055 21.5178L15.1301 17.3424V23.585Z"
        fill="#0052B4"
      />
      <path
        d="M17.3444 15.1302L21.5198 19.3056C22.4623 18.0793 23.1731 16.6657 23.587 15.1302H17.3444Z"
        fill="#0052B4"
      />
      <path
        d="M23.8984 10.4348H13.5653H13.5653V0.101578C13.0529 0.034875 12.5305 0 12 0C11.4694 0 10.9471 0.034875 10.4348 0.101578V10.4347V10.4347H0.101578C0.034875 10.9471 0 11.4695 0 12C0 12.5306 0.034875 13.0529 0.101578 13.5652H10.4347H10.4347V23.8984C10.9471 23.9651 11.4694 24 12 24C12.5305 24 13.0529 23.9652 13.5652 23.8984V13.5653V13.5653H23.8984C23.9651 13.0529 24 12.5306 24 12C24 11.4695 23.9651 10.9471 23.8984 10.4348Z"
        fill="#D80027"
      />
      <path
        d="M15.1304 15.1312L20.4852 20.4861C20.7315 20.2399 20.9665 19.9825 21.1906 19.7157L16.6062 15.1312H15.1304V15.1312Z"
        fill="#D80027"
      />
      <path
        d="M8.86951 15.1312H8.86941L3.51465 20.486C3.76084 20.7322 4.01823 20.9672 4.28504 21.1913L8.86951 16.6068V15.1312Z"
        fill="#D80027"
      />
      <path
        d="M8.86939 8.86911V8.86902L3.51458 3.51416C3.2683 3.76035 3.03336 4.01774 2.8092 4.28455L7.39372 8.86907H8.86939V8.86911Z"
        fill="#D80027"
      />
      <path
        d="M15.1304 8.8702L20.4853 3.5153C20.2391 3.26901 19.9817 3.03408 19.7149 2.80997L15.1304 7.39448V8.8702Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_125_13182">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default EnglishFlag;
